import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { useDispatch } from 'react-redux';
import { setAuthUser } from '../store/slices/adminSlice';

const ProtectedRoute = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser) {
                dispatch(setAuthUser({
                    uid: currentUser.uid,
                    email: currentUser.email,
                    displayName: currentUser.displayName
                }));
            } else {
                dispatch(setAuthUser(null));
            }
            setUser(currentUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [dispatch]);

    if (loading) {
        return (
            <div className="min-vh-100 flex-center bg-gray-50">
                <div className="text-center">
                    <div className="spinner-border text-main-600 mb-16" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="text-gray-500 text-sm fw-semibold">Verificando sesión...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
